/**
 * Tramite-related label constants
 * Define terminology used throughout the application for tramite participants
 */

export const TRAMITE_LABELS = {
  // Singular forms
  TRANSFERENTE: 'Transferente',
  ADQUIRIENTE: 'Adquiriente',

  // Plural forms
  TRANSFERENTES: 'Transferentes',
  ADQUIRIENTES: 'Adquirientes',

  // Default/empty states
  SIN_TRANSFERENTE: 'Sin transferente',
  SIN_ADQUIRIENTE: 'Sin adquiriente',
} as const;
